import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { graphql, useStaticQuery } from 'gatsby'
import Image from 'gatsby-image'
const Sobre = (props) => {
	const { id } = props;
	const getImg = graphql`
	{
	esquema:file(relativePath: {eq: "esquema.png"}) {
		childImageSharp {
		fluid(maxWidth: 1000) {
			...GatsbyImageSharpFluid
		}
		}
	}
	}`

	const { esquema } = useStaticQuery(getImg);
	return (

		<section className="page-section" >
			<div className="name-section" id={id}>
				<Container>
					<h2 className="text-center mt-0 title-general">¿Cómo funciona Confirmae?</h2>
					<hr className="divider my-4" />

					<div className="cont-esquema">
						<Image fluid={esquema.childImageSharp.fluid} />
					</div>

					<Row>
						<Col>
							<ol className="pasos">
								<li>
									El <b className="color-pagador">PAGADOR</b> carga una nómina de facturas que adeuda a diversos <b className="color-proveedor">PROVEEDORES</b>. <b className="color-confirmae">CONFIRMAE</b> valida la nómina con el “Registro de Compras” del <b className="color-pagador">PAGADOR</b> en el SII.
							</li>
								<li>
									<b className="color-confirmae"><b className="color-confirmae">CONFIRMAE</b></b> envía correos a cada <b className="color-proveedor">PROVEEDOR</b> con el listado de facturas que debe ceder al <b className="color-factoring">FACTORING</b>, proporcionando además un acceso a la plataforma.
							</li>
								<li>
									El <b className="color-proveedor">PROVEEDOR</b> accede a la plataforma <b className="color-confirmae">CONFIRMAE</b> para ceder los documentos registrados en la operación. En caso de que el <b className="color-proveedor">PROVEEDOR</b> realice la cesión desde una plataforma externa, <b className="color-confirmae">CONFIRMAE</b> captura la cesión directamente desde el SII.
							</li>
								<li>
									El <b className="color-factoring">FACTORING</b> puede hacer seguimiento de todos los documentos en sus nóminas, pudiendo gestionar los documentos pendientes de cesión con cada <b className="color-proveedor">PROVEEDOR</b>, y pagando todas las facturas cedidas informadas por <b className="color-confirmae"><b className="color-confirmae">CONFIRMAE</b></b>
								</li>
								<li>
									El <b className="color-factoring">FACTORING</b> puede cargar comprobantes de los pagos efectuados, informando por una parte al <b className="color-proveedor">PROVEEDOR</b> y, por otro lado, notificando al <b className="color-pagador">PAGADOR</b> los documentos que ya se encuentran financiados.
							</li>
							</ol>
						</Col>
					</Row>
				</Container>
			</div>
		</section>
	)
}

export default Sobre
